import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleResponsiveBannerComponent } from './simple-responsive-banner.component';
import { CmsConfig, UrlModule, provideConfig } from '@spartacus/core';
import { GenericLinkModule } from '@spartacus/storefront';
import { CustomMediaModule } from '../../media/media.module';

@NgModule({
  declarations: [SimpleResponsiveBannerComponent],
  imports: [CommonModule, CustomMediaModule, GenericLinkModule, UrlModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SimpleResponsiveBannerComponent: {
          component: SimpleResponsiveBannerComponent,
        },
      },
    }),
  ],
})
export class SimpleResponsiveBannerModule {}
